import $ from 'jquery';
import 'bootstrap';
import { WWW_DOMAIN } from '../../constants';

export const init = () => {
  // let currentValue = 0;
  const elSelectFirst = $('.mall-select-first');
  $('button.select-course-confirm').on('click', () => {
    if (elSelectFirst.val() == 0) {
      alert('请选择报考时间!');
      elSelectFirst.focus();
      return;
    } else if (elSelectFirst.val() == 1) {
      $('#cpa-categoryModal').modal('hide');
      window.location.href = `${WWW_DOMAIN}/mall/cpa`;
    } else if (elSelectFirst.val() == 2) {
      $('#cpa-categoryModal').modal('hide');
      window.location.href = `${WWW_DOMAIN}/mall/cpa2`;
    }
  });
};
